import { render, staticRenderFns } from "./practicingLawyer.vue?vue&type=template&id=0c86c0cb&scoped=true&"
import script from "./practicingLawyer.vue?vue&type=script&lang=js&"
export * from "./practicingLawyer.vue?vue&type=script&lang=js&"
import style0 from "./practicingLawyer.vue?vue&type=style&index=0&id=0c86c0cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86c0cb",
  null
  
)

export default component.exports